import React from 'react';

import { Flex } from '@chakra-ui/react';

import { IconRow } from 'containers/Texts';

export default function DriverInfo({
  drivers, vehicle, initialKm, finalKm,
}) {
  return (
    <Flex flexDir="column">
      <IconRow
        label="truck"
        value={vehicle?.licensePlate}
        direction="row"
      />
      {drivers?.map((driver) => (
        <IconRow
          key={`driver-${driver.id}`}
          label="id-card"
          value={driver.name}
          direction="row"
        />
      ))}
      {initialKm && (
      <IconRow
        label="tachometer-alt"
        value={`Inicial: ${initialKm}Km`}
        direction="row"
      />
      )}
      {finalKm && (
      <IconRow
        label="tachometer-alt"
        value={`Final: ${finalKm}Km`}
        direction="row"
      />
      )}
    </Flex>
  );
}
